import { actionType } from "../actions/bybetjentrollerAction";
import { CreateNewReducer } from "../utils/reducerUtils";

const initialState = [];
const bybetjentRollerReducer = (state = initialState, action) =>
  CreateNewReducer(state, action, actionType);

export default bybetjentRollerReducer;
